module.exports = __webpack_public_path__ + "img/bg_cover.9bd1cfea.png";